import React from "react";
import { AbsoluteFill } from "remotion";
import { TrackType } from "../remotion-timeline/types";
import { Layer } from "./layer";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { PlayerRef } from "@remotion/player";

type CanvasCompositionProps = {
  tracks: TrackType[];
  playerRef: React.RefObject<PlayerRef | null>;
};

const layerStyle: React.CSSProperties = {
  overflow: "hidden",
  background: "white",
};

/**
 * The default composition for the timeline that renders the layers and respects the z-index.
 * @param tracks - The tracks to render.
 */
export const CanvasComposition: React.FC<CanvasCompositionProps> = ({
  tracks,
  playerRef,
}) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <AbsoluteFill>
        <AbsoluteFill style={layerStyle}>
          {tracks
            .slice()
            .reverse()
            .map((track) => {
              return (
                <Layer
                  key={track.id}
                  track={track}
                  playerRef={playerRef}
                ></Layer>
              );
            })}
        </AbsoluteFill>
      </AbsoluteFill>
    </DndProvider>
  );
};
